import CvProcessorPage from "../features/cv-processor/CvProcessorPage";

export default function CvProcessorPageRoute() {
  return <CvProcessorPage />;
}
